import React from 'react';
import BlockContainer from './BlockContainer';
import Button from '../Button';
import FadeIn from '../animations/FadeIn';
import { BlogPostCard } from '../blog';

export default function ResourceCards({
  title,
  description,
  resources,
  link,
  bgColor,
  buttonColor,
  textColor,
  padding,
}) {
  return (
    <BlockContainer
      bgColor={bgColor}
      textColor={textColor}
      padding={padding}
      title={title}
      description={description}
    >
      {resources?.length > 0 ? (
        <FadeIn>
          <div className="flex flex-wrap justify-center gap-8 my-10 text-left">
            {resources.map((r, i) => (
              <BlogPostCard
                key={i}
                node={r}
                isNetlify
                isBlock
                fullDescription
              />
            ))}
          </div>
        </FadeIn>
      ) : null}

      {link?.link_text && link?.link_url ? (
        <Button color={buttonColor} solid lg to={link.link_url}>
          {link.link_text}
        </Button>
      ) : null}
    </BlockContainer>
  );
}
